<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <like-list viewMode="program" :showRecommend="showRecommend"/>
        <recommend-program v-if="isShowRecommend"/>
      </div>
    </section>
  </div>
</template>

<script>
import LikeList from '@/components/mypooq/LikeList'
import RecommendProgram from '@/components/mypooq/RecommendProgram'
import { titleTagNameChange } from '@/common/utils/common'
export default {
  components: {
    LikeList,
    RecommendProgram
  },
  data () {
    return {
      isShowRecommend: false
    }
  },
  methods: {
    showRecommend () {
      this.isShowRecommend = true
    }
  },
  created () {
    titleTagNameChange('구독내역 : 웨이브 MY')
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
<style lang="css">
.mypooq .mypooq-info-body{
  padding-bottom: 0;
}
</style>
